export { BaMenuService } from './services';
export * from './theme.constants';
export * from './theme.configProvider';
export * from './theme.config';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/index.ts